exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loader-content[data-v-8068bf0c]{width:100%;height:100vh}.login-main-content[data-v-8068bf0c]{background:#f4f4f4 50%;background-size:cover}.login-main-content .background-img[data-v-8068bf0c],.login-main-content[data-v-8068bf0c]{min-height:100vh;max-width:100%!important;padding:0!important;font-weight:400;text-align:left;-webkit-box-sizing:border-box;box-sizing:border-box;font-style:normal;font-size:14px;line-height:1.15;position:relative;width:100%;height:100%}.login-main-content .background-img[data-v-8068bf0c]{cursor:pointer;background-position:50%;background-size:cover}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8068bf0c","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/office/js/components/office-v6/auth/index.vue
// module id = QZh4
// module chunks = 0